import { Component, findComponents } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { HorizontalNav } from '../../horizontal-nav/js/horizontal-nav';
import '../../horizontal-nav/js/horizontal-nav'; // needed so that TS does not remove it as unused import

// The @Component decorator will connect the class with `data-g-name="StepNavigation"` elements.
@Component('StepNavigation')
export class StepNavigation extends GondelJqueryComponent {
	public sync() {
		const horizontalNav = findComponents<HorizontalNav>(this._ctx, 'HorizontalNav');
		horizontalNav[0].initializeScrollBehaviour();
	}
}
